<template>
  <svg
    :class="size"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_9212_68116)">
      <path
        d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z"
        fill="white"
      />
      <path
        d="M0 11.9997C0 17.1593 3.2565 21.5577 7.82611 23.2533V0.746094C3.2565 2.44156 0 6.84012 0 11.9997Z"
        fill="#008A58"
      />
      <path
        d="M23.9999 11.9997C23.9999 6.84013 20.7434 2.44156 16.1738 0.746094V23.2534C20.7434 21.5578 23.9999 17.1593 23.9999 11.9997Z"
        fill="#008A58"
      />
    </g>
    <defs>
      <clipPath id="clip0_9212_68116">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script>
export default {
  props: {
    size: {
      type: String,
      default: () => 'h-6 w-6'
    }
  }
}
</script>
